import { render, staticRenderFns } from "./watchCodeDetails.vue?vue&type=template&id=f18451cc&scoped=true&"
import script from "./watchCodeDetails.vue?vue&type=script&lang=js&"
export * from "./watchCodeDetails.vue?vue&type=script&lang=js&"
import style0 from "./watchCodeDetails.vue?vue&type=style&index=0&id=f18451cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18451cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f18451cc')) {
      api.createRecord('f18451cc', component.options)
    } else {
      api.reload('f18451cc', component.options)
    }
    module.hot.accept("./watchCodeDetails.vue?vue&type=template&id=f18451cc&scoped=true&", function () {
      api.rerender('f18451cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/playerDetails/components/watchCodeDetails.vue"
export default component.exports